import React, { useEffect, useState } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import "../css/Requisitions.css";
import Sidebar from './Sidebar';



const EveryonesReviewedRequisitions = () => {
  const navigate = useNavigate();
  const location = useLocation(); 
  const [requisitions, setRequisitions] = useState([]);
  const theUserType = localStorage.getItem('userType');
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(location.state?.defaultTab || 'Submitted');  
  const theFirstName = localStorage.getItem('theFirstName'); 
  const theLastName = localStorage.getItem('theLastName'); 
  const fullName = theFirstName + " " + theLastName;


  const handleView = (requisitionID) => {
      navigate(`/view-requisition/${requisitionID}`);
  };

  const handleSurrender = (requisitionID) => {
    navigate(`/surrender/${requisitionID}`);
};

  
const fetchRequisitionsByStatus = async (status) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Requisition/status`, {
            params: { status },
        });
        console.log(response.data); 
        setRequisitions(response.data.$values || []); 
        setError(null); 
    } catch (error) {
        console.error(error); 
        if (error.response && error.response.status === 404) {
            setError(`No requisitions found for status: ${status}.`);
        } else {
            setError('Error fetching requisitions.');
        }
        setRequisitions([]); 
    }
};

useEffect(() => {
    fetchRequisitionsByStatus(activeTab);
}, [activeTab]); 


const handleTabClick = (tab) => {
    setActiveTab(tab);
};

const getStatusClass = (status) => {
    if (status === "Draft") return "status-draft"; 
    if (status === "Submitted") return "status-submitted";
    if (status === "Surrender Submitted") return "status-surrender-submitted";
    if (status.startsWith("Reviewed by")) return "status-reviewed";
    if (status === "Approved") return "status-approved";
    if (status === "Surrender Approved") return "status-surrender-approved";
    if (status === "Disapproved") return "status-disapproved"; 
    if (status === "Disbursed") return "status-disbursed"; 

        
    return ""; 
  };
      
    return (
        <div id="wrapper">
          
          <Sidebar userType={theUserType} />


{/* Content Wrapper */}

<div id="content-wrapper" className="d-flex flex-column">

    {/* Main Content */}
    <div id="content">



    {/* Topbar */}
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

    {/* Sidebar Toggle */}
    <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
        <i className="fa fa-bars"></i>
    </button>

    {/* Topbar Search */}
    <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
        <div className="input-group">
            <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                aria-label="Search" aria-describedby="basic-addon2" />
            <div className="input-group-append">
                <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                </button>
            </div>
        </div>
    </form>

    {/* Topbar Navbar */}
    <ul className="navbar-nav ml-auto">

        <TopBarIcons />
        
        

    </ul>

    </nav>
    {/* End of Topbar */}






        {/* Begin Page Content */}
        <div className="container-fluid">

            <h1 className="h3"> Reviewed Requisitions</h1>
             
            <div className="tabs">
                <button
                    className={`nav-link ${activeTab === 'Submitted' ? 'active' : ''}`}
                    onClick={() => handleTabClick('Submitted')}
                >
                    Submitted
                </button>
                <button
                    className={`nav-link ${activeTab === `Reviewed by ${fullName}` ? 'active' : ''}`}
                    onClick={() => handleTabClick(`Reviewed by ${fullName}`)}
                >
                    Reviewed
                </button>
            </div>


            <div id="new-requisition"> 
                <button type="button" id="new-requisition-button" className="btn btn-primary">
                    <i id="plus-icon" className="fas fa-plus-circle"></i>  
                    <Link className="btn btn-primary" to="/reqform">New Requisition</Link>
                </button>
            </div>

            <div id="requsition-table">
                <table className="table req-table-bordered">
                    <thead>
                        <tr>
                            <th className="req-th">Activity Date</th>
                            <th className="req-th">Activity Name</th>
                            <th className="req-th">Activity Purpose</th>
                            <th className="req-th">District</th>
                            <th className="req-th">AP</th>
                            <th className="req-th">Status</th>
                            <th className="req-th">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    {requisitions.map((requisition) => {
                            const date = new Date(requisition.activityDate);
                            const day = date.getDate();
                            const month = date.toLocaleString("en-US", { month: "long" });
                            const year = date.getFullYear();
                            
                            return (
                                <tr key={requisition.requisitionID}>
                                    <td>{`${day} ${month} ${year}`}</td>
                                <td>{requisition.activityName}</td>
                                <td>{requisition.activityPurpose}</td>
                                <td>{requisition.district}</td>
                                <td>{requisition.areaProgram}</td>
                                <td>
                                    <div className={getStatusClass(requisition.status)}>
                                    {requisition.status}
                                    </div>
                                </td>
                                <td>
                                  <div className="button-container">
                                      <Link className="nav-link" to={`/review-requisition/${requisition.requisitionID}`}>
                                          <div className="view-button btn btn-sm" onClick={() => handleView(requisition.requisitionID)}>
                                              <i className="fas fa-file-alt button-icon"></i>
                                              <span>Review</span>
                                          </div>
                                      </Link>
                                  </div>
                              </td>

                            </tr>
                            ); 
                          })}
                    </tbody>
                </table>
            </div>





        </div>
        {/* End of container-fluid */}

    </div>
    {/* End of Main Content */}

    {/* Footer */}
    <footer className="sticky-footer bg-white">
        <div className="container my-auto">
            <div className="copyright text-center my-auto">
                <span>Copyright &copy; Farm Concern International 2025 </span>
            </div>
        </div>
    </footer>
    {/* End of Footer */}

</div>


    
    {/* End of Content Wrapper */}


           
          
          
        </div>

  );
   
};

export default EveryonesReviewedRequisitions;